import { createContext, useContext, useEffect, useState } from "react";
import { translations } from ".";

const LanguageContext = createContext();
export const LanguageProvider = ({children}) => {
  const lang = localStorage.getItem('lang');
  const [language, setLanguage] = useState(lang || 'ar');

  useEffect(() => {
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
  }, [language]);

  const toggleLanguage = (targetLanguage) => {
    if (targetLanguage === language) {
      return ;
    }

    localStorage.setItem('lang', targetLanguage);
    setLanguage(targetLanguage);
    window.dispatchEvent(new Event('languageChange'));
    document.documentElement.dir = targetLanguage === 'ar' ? 'rtl' : 'ltr';
  }

  const t = (key) => {
    return key.split('.').reduce((obj, i) => {
      if (obj && obj[i] !== undefined) {
        return obj[i];
      }
      return key;
    }, translations[language]);
  }

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}
export const useLanguage = () => useContext(LanguageContext);